export enum AttachmentType {
  Image,
  Video,
}

export enum AttachingMethod {
  Button,
  Drop,
  Paste,
}

type CommonAttachment = Readonly<{
  name: string;
  url: string;
  width: number;
  height: number;
  size: number;
  attachingMethod: AttachingMethod;
  mimeType?: string;
  filePath?: string;
  previewLoaded?: boolean;
  previewFailed?: boolean;
}>;

export type ImageAttachment = CommonAttachment &
  Readonly<{
    type: AttachmentType.Image;
  }>;

export type VideoAttachment = CommonAttachment &
  Readonly<{
    type: AttachmentType.Video;
    iconUrl: string;
    duration: number; // ms
    format: string;
  }>;

// Discriminating union by 'type'
export type Attachment = ImageAttachment | VideoAttachment;
